import { WebSocketReceiveWithSigningUserId } from './web-socket-receive-with-signing-user-id';
import type { Menu } from '../../../menu/dto/menu';

export class WebSocketReceiveReloadTemplate extends WebSocketReceiveWithSigningUserId {
  override payload: {
    SigningUserId: string;
    TemplateId: string;
    FileName: string;
  };

  isAboutThis(template: Menu): boolean {
    if (!template) return false;
    return template?.id === this.payload?.TemplateId;
  }

  getGroupingKey(): string {
    return `${this.payload?.SigningUserId}-${this.payload?.TemplateId}`;
  }
}
